import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import { commonAPI } from 'api/commonAPI';
import DeleteIcon from 'assets/images/icon/DeleteIcon';
import LargePlusIcon from 'assets/images/icon/LargePlusIcon';
import SearchIcon from 'assets/images/icon/SearchIcon';
import TagCloseIcon from 'assets/images/icon/TagCloseIcon';
import UploadIcon from 'assets/images/icon/UploadIcon';
import Zoom from 'assets/images/icon/Zoom';
import {
    businessCheckBoxItems,
    careerCheckboxData,
    classesKeywords,
    financialCheckboxData,
    lifeCycleCheckboxData, mindsetCheckboxData
} from 'constants/topic';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  cloneDeep,
  uniq,
} from 'lodash';
import { useQuery } from 'react-query';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { animated } from 'react-spring';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import {
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import {
  fireSubmit,
  isAdmin,
  publishState,
} from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import { DropdownMenu } from 'view/components';
import {fadeIn} from "../../../../../styled/StyledComponent";

dayjs.extend(utc);

const date = [2024, 1 - 1, 10, 2, 0];
let ms = dayjs(Date.UTC.apply(null, date)).utc().format("YYYY-MM-DD hh:mm:ss");
// date 초기세팅
interface DetailsProps {
    subCategoryItem?: any;
    createId?: any;
}

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
    overlay?: boolean;
}

interface MenuProps {
    active?: boolean;
    display?: boolean;
}

interface ITimezone {
    label: string;
    value: string;
}

// 배열로 변환

const returnTopic = (item) => {
    switch(item)  {
        case "BUSINESS" :{
            return businessCheckBoxItems
        };
        case "FINANCE":{
            return financialCheckboxData
        };
        case "CAREER":{
            return careerCheckboxData
        };
        case "LIFESTYLE":{
            return lifeCycleCheckboxData
        };
        case "MINDSET":{
            return mindsetCheckboxData
        };
    }
}

function getCurrentTimeZone() {
    // 브라우저에서 현재 사용자의 타임존을 얻기
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
}

const publshObj = {
    tag: "NEW",
    keyword: [],
    publishDateTime: ms,
    publishNow: true,
    skillsTopics: [],
    // timeZone: {
    //     id: "string",
    //     rawOffset: 0,
    // },
    timeZone: getCurrentTimeZone(),
};
const Details: React.FC<DetailsProps> = () => {
    const {
        state: { createId },
    } = useLocation();
    const thumbnailInput = useRef(null);
    const navigate = useNavigate();
    const admin = useRecoilValue(isAdmin);
    const [classList, setClassList] = useState([]);
    const [publishItem, setPublishItem] = useRecoilState(publishState);
    const [publishData, setPublishData] = useState(publshObj);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const [percentage, setPercentage] = useState(0);
    const [videoFileName, setVideoFileName] = useState("");
    const [thumbnailData, setTumbnailData] = useState(null);
    const [popupState, setPopupState] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [createTitle, setCreateTitle] = useState("");
    const [uploadData, setUploadData] = useState({
        title: "",
        thumbnail: null,
        classesId: null,
    });

    const onClickPublishStat = (status: boolean) => {
        setPublishData({
            ...cloneDeep(publishData),
            publishNow: status,
        });
    };

    console.log("@createId",createId);

    const getCoachingData = async () => {
        await coachingAPI.getProductById(createId).then((res) => {
            console.log("coa data", res);
            if (!isEmpty(res)) {
                setImageUrl(res?.data?.coaching?.thumbnail?.url)
                setUploadData({
                    title: res?.data?.coaching?.title,
                    thumbnail: res?.data?.coaching?.thumbnail,
                    // classesId: "",
                    classesId:res?.data?.classesId // API 업데이트 전 임시
                });
            }
        });
    };

    const getCoachingList = async () => {
        await coachingAPI
            .getCoachingList({
                params: {
                    progress:"IN_PROGRESS",
                },
            })
            .then((res) => {
                console.log("coa data", res);
                const c = cloneDeep(res?.content);
                const find = c.find(item => {
                    return item.id === createId
                })
                setImageUrl(find?.thumbnail?.url)
                setUploadData({
                    title: find?.title,
                    thumbnail: find?.thumbnail,
                    // classesId: "",
                    classesId:classList[0]?.id // API 업데이트 전 임시
                });
            });
    };

    const putCoachingData = async () => {
        await coachingAPI.putCoachingDetail(createId, {
            data: getFormData(),
        })
        .then(async res => {
            if(admin){
                await coachingAPI
                    .postAdminSubmitCoaching(createId, {
                        data:{...cloneDeep(publishData)}
                    })
                    .then(async (res) => {
                        console.log("adminData@@", res);
                        navigate("/create_coaching/products", {
                            state:{
                                createId:createId
                            }
                        })
                    });
            }else{
                if(res?.isSuccess){
                    navigate("/create_coaching/products", {
                        state:{
                            createId:createId
                        }
                    })
                }
            }
        })
    };

    const getClassList = async () => {
        if(admin){
            await classesAPI.getAdminClassList({}).then(res => {
                console.log("classList", res);
                setClassList(cloneDeep(res?.data?.content));
            })
        }else{
            await classesAPI.getClassList({}).then((res) => {
                console.log("classList", res);
                setClassList(cloneDeep(res?.data?.content));
            });
        }
    };

    const getCategory = async () => {
        const result = await commonAPI.getCategory(null).then((res) => {
            return res?.data;
        });

        if (!isEmpty(result)) {
            const data = result?.map((item: any) => item.category);
            const category = uniq([...data]);
            setData({ category: [...category], categoryData: result })
        }
        console.log("result", result);
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageUrl(e.target.result);
                setUploadData({
                    ...uploadData,
                    thumbnail: e.target.result,
                });
            };
            reader.readAsDataURL(file);
        }

        // FormData 생성
        const formData = new FormData();
        formData.append("thumbnail", selectedFile);

        setTumbnailData(file);
    };
    const getFormData = () => {
        const formData = new FormData();
        if(thumbnailData !== null){
            const thumbnailBlob = new Blob([thumbnailData], {
                type: thumbnailData?.type,
            });
            formData.append("thumbnail", thumbnailBlob, thumbnailData?.name);
        };
        formData.append("coachingInitRequest",JSON.stringify({
            title:uploadData?.title,
            classesId:uploadData?.classesId
        }))
        // formData.append("classesId", uploadData?.classesId);
        // formData.append("title", uploadData?.title);
        return formData;
    };

    console.log("form", getFormData());

    const [data, setData] = useState(null);

    useEffect(() => {
        getCategory()
    }, []);
    // const { data, status: getCategoryStatus } = useQuery("getCategory", getCategory);
    const getSubCategory = (category: string): { subCategory: any; subCategoryDataArray: any } => {
        if (isEmpty(data)) return null;
        const subCategory = data?.categoryData
            ?.filter((item: any) => {
                return item?.category === category;
            })
            .map((item: any) => {
                return {
                    ...item,
                    dropdownItem: item?.subCategory,
                };
            });
        console.log("subCategoryDataArray", subCategory);
        return {
            subCategory: subCategory[0]?.subCategory || "",
            subCategoryDataArray: subCategory,
        };
    };
    const onClickTagDropDown = (item: any, key: string) => {
        setPublishData({
            ...publishData,
            [key]: item,
        });
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setUploadData({
            ...uploadData,
            [key]: selectItem,
        });
    };

    const onChangeDropdown = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        setUploadData({
            ...uploadData,
            [key]: e.target.value,
        });
    };

    const onChangeTitle = (value: string) => {
        setCreateTitle(value);
    };

    const createClass = async () => {
        await classesAPI.postClass(createTitle).then((res) => {
            navigate("/create/details", {
                state: {
                    createId: res?.data?.id,
                },
            });
            setPopupState(false);
        });
    };
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef?.current?.focus();
    }, [inputRef?.current]);


    const getAdminData = async () => {
        await coachingAPI.getAdminSubmitCoaching(createId).then((res) => {
            // const mapDate = res?.publishDateTime?.map((item, index) => {
            //     if (index === 1) {
            //         return item - 1;
            //     }
            //     return item;
            // });
            // const dateItem = dayjs(Date.UTC.apply(null, mapDate)).utc().format();
            console.log("adminData@@1", res);
            if (!isEmpty(res)) {
                setPublishData({
                    keyword: [...res?.data?.keyword]?.filter(item => {
                        return item !== ''
                    }),
                    publishDateTime: res?.data?.publishDateTime,
                    publishNow: res?.data?.publishNow,
                    skillsTopics: res?.data?.skillsTopics?.filter(item => {
                        return item !== ''
                    }),
                    timeZone: res?.data?.timeZone,
                    tag: isEmpty(res?.data?.tag) ? "NEW" : res?.data?.tag,
                });
            }
        });
    };
    const postAdminData = async () => {
        await classesAPI
            .postAdminClass(createId, {
                data: { ...cloneDeep(publishData) },
            })
            .then((res) => {
                console.log("adminData@@", res);
                if (!isEmpty(res?.data)) {
                    setPublishData({
                        ...res,
                    });
                }
            });
    };

    const removeImage = () => {
        thumbnailInput.current.value = "";
        setImageUrl("");
    };

    useEffect(() => {
        if (admin) {
            getAdminData();
        }
    }, [admin]);
    console.log("admin", admin);

    const getInProgress = () => {
        if (admin) {
            commonAPI?.getProgress(createId);
        }
    };

    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            })
        return arr || [];
    };

    const handleOnSearch = (string, results) => {
        console.log(string, results);
    };

    const handleOnHover = (result) => {
        console.log(result);
    };

    const handleOnSelect = (item, key) => {
        console.log(item);
        const copy = cloneDeep(publishData);
        copy[key].push(item);
        setPublishData(copy);
    };

    const handleOnFocus = () => {
        console.log("Focused");
    };

    const formatResult = (item) => {
        return (
            <DropdownItem>
                {/* <span style={{ display: "block", textAlign: "left" }}>id: {item.id}</span> */}
                <span>{item.name}</span>
            </DropdownItem>
        );
    };

    const onclickRemove = (index: number, key: string) => {
        const copy = cloneDeep(publishData);
        copy[key].splice(index, 1);
        setPublishData(cloneDeep(copy));
    };

    useEffect(() => {
        getClassList();
    }, [createId]);

    useEffect(() => {
        if (createId === null) {
            setPopupState((v) => !v);
        }
    }, [createId]);

    useEffect(() => {
        setPublishItem(cloneDeep(publishData));
    }, [publishData]);

    useEffect(() => {
        getInProgress();
    }, [admin]);

    useEffect(() => {
        getCoachingData();
    }, []);

    console.log("cid", getClassItems())
    console.log("u", uploadData)
    if(isEmpty(createId)) return <div></div>
    
    return (
        <React.Fragment>
            <Container>
                {!isEmpty(uploadData) && (
                    <Contents>
                        <Row>
                            <FormBox>
                                <dt style={{paddingBottom:2}}>
                                    Title<strong>*</strong>
                                </dt>
                                <dd>
                                    <FormBoxItemWrap

                                    >
                                        <li>
                                            <FormItem>
                                                <input
                                                    ref={inputRef}
                                                    onChange={(e) => {
                                                        onChangeDropdown(e, "title");
                                                    }}
                                                    type="text"
                                                    value={uploadData.title}
                                                    placeholder="Enter a title"
                                                    maxLength={70}
                                                />
                                                <TextLength>
                                                    {70 - uploadData?.title?.length}
                                                </TextLength>
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Row>
                        <Row display={"flex"}>
                            <Col>
                                <FormBox>
                                    <dt>
                                        Class<strong>*</strong>
                                    </dt>
                                    <p>
                                        Select the class where this coaching belongs. Think about which class this fits best or where it will improve student's learning experience.
                                    </p>
                                    <dd>
                                        <FormBoxItemWrap>
                                            <li>
                                                <FormItem>
                                                    <DropdownMenu
                                                        altText={"Select classes"}
                                                        selected={getClassItems()?.find(item => {
                                                            return item.id === uploadData?.classesId
                                                        })?.classTitle || ""}
                                                        items={getClassItems() || []}
                                                        state={"price"}
                                                        onClick={(item, key, index, obj) => {
                                                            console.log("obj", obj)
                                                            setUploadData({
                                                                ...cloneDeep(uploadData),
                                                                classesId: obj?.id
                                                            })
                                                            // onClickDropdown(
                                                            //     item,
                                                            //     key = "classesId",
                                                            //     index,
                                                            //     obj
                                                            // );
                                                        }}
                                                    />
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                            </Col>
                        </Row>

                        <Row display={"flex"}>
                            <Col>
                                <ThumbnailWrap>
                                    <ThumbnailTitle>
                                        Thumbnail<strong>*</strong>
                                    </ThumbnailTitle>
                                    <ThumbnailText>
                                        Choose or upload an image that represents the essence of your class.
                                        A well-designed thumbnail can help your class stand out and attract the attention of potential student.
                                    </ThumbnailText>
                                    <ThumbnailUpload>
                                        <ThumbnailView overlay={isEmpty(imageUrl)}>
                                            {!isEmpty(imageUrl) && (
                                                <ThumbnailButtonList>
                                                    <li>
                                                        <button>
                                                            <Zoom />
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button onClick={removeImage}>
                                                            <DeleteIcon />
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button>
                                                            <UploadIcon />
                                                        </button>
                                                    </li>
                                                </ThumbnailButtonList>
                                            )}
                                            {isEmpty(imageUrl) ? (
                                                <UploadText>
                                                    <LargePlusIcon />
                                                    <p>Upload or Select Thumbnail</p>
                                                </UploadText>
                                            ) : (
                                                <img src={imageUrl} alt="" />
                                            )}

                                            <input
                                                type={"file"}
                                                accept="image/*"
                                                // onChange={handleFileChange}
                                                onChange={(e) => {
                                                    handleFileChange(e);
                                                }}
                                                ref={thumbnailInput}
                                            />
                                        </ThumbnailView>
                                    </ThumbnailUpload>
                                </ThumbnailWrap>
                            </Col>
                        </Row>
                    </Contents>
                )}

                {admin && (
                    <AdminContents>
                        <Col style={{ width: "30%" }}>
                            <FormBox>
                                <dt>
                                    Coaching Tag<strong>*</strong>
                                </dt>
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <DropdownMenu
                                                    altText={"Tag"}
                                                    selected={publishData?.tag}
                                                    items={["NEW", "POPULAR", "UPDATED", "NO_TAG"]}
                                                    state={"tag"}
                                                    onClick={onClickTagDropDown}
                                                />
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                        <div style={{ height: 20 }}></div>
                        <Row>
                            <Col style={{ width: "100%" }}>
                                <FormBox>
                                    <dt>
                                        Skills/Topics<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap style={{ width: "70%" }}>
                                            <li>
                                                <FormItem>
                                                    <ReactSearchAutocomplete
                                                        items={
                                                            businessCheckBoxItems
                                                        }
                                                        onSearch={handleOnSearch}
                                                        onHover={handleOnHover}
                                                        onSelect={(item) => {
                                                            console.log("item", item);
                                                            handleOnSelect(
                                                                item?.name,
                                                                "skillsTopics"
                                                            );
                                                        }}
                                                        className={"topics"}
                                                        onFocus={handleOnFocus}
                                                        styling={{
                                                            borderRadius: "8px",
                                                            hoverBackgroundColor: "#33333360",
                                                        }}
                                                        autoFocus
                                                        showIcon={false}
                                                        formatResult={formatResult}
                                                    />
                                                    <SearchIconBox>
                                                        <SearchIcon />
                                                        <span>Search</span>
                                                    </SearchIconBox>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                                <Tags>
                                    {publishData?.skillsTopics?.map((item, index) => (
                                        <TagItem>
                                            <span>{item}</span>
                                            <div
                                                onClick={() => {
                                                    onclickRemove(index, "skillsTopics");
                                                }}
                                            >
                                                <TagCloseIcon />
                                            </div>
                                        </TagItem>
                                    ))}
                                </Tags>
                            </Col>
                        </Row>
                        <div style={{ height: 0 }}></div>
                        <Row>
                            <Col style={{ width: "100%" }}>
                                <FormBox>
                                    <dt>
                                        Keywords<strong>*</strong>
                                    </dt>
                                    <dd>
                                        <FormBoxItemWrap style={{ width: "70%" }}>
                                            <li>
                                                <FormItem className="search">
                                                    <ReactSearchAutocomplete
                                                        items={classesKeywords?.filter((item) => {
                                                            return !publishData?.keyword?.find(
                                                                (findItem) => {
                                                                    return findItem == item.name;
                                                                }
                                                            );
                                                        })}
                                                        onSearch={handleOnSearch}
                                                        onHover={handleOnHover}
                                                        onSelect={(item) => {
                                                            console.log("item", item);
                                                            handleOnSelect(item?.name, "keyword");
                                                        }}
                                                        className={"keywords"}
                                                        onFocus={handleOnFocus}
                                                        styling={{
                                                            borderRadius: "8px",
                                                            hoverBackgroundColor: "#33333360",
                                                        }}
                                                        autoFocus
                                                        showIcon={false}
                                                        formatResult={formatResult}
                                                    />
                                                    <SearchIconBox>
                                                        <SearchIcon />
                                                        <span>Search</span>
                                                    </SearchIconBox>
                                                </FormItem>
                                            </li>
                                        </FormBoxItemWrap>
                                    </dd>
                                </FormBox>
                                <Tags>
                                    {publishData?.keyword?.map((item, index) => (
                                        <TagItem>
                                            <span>{item}</span>
                                            <div
                                                onClick={() => {
                                                    onclickRemove(index, "keyword");
                                                }}
                                            >
                                                <TagCloseIcon />
                                            </div>
                                        </TagItem>
                                    ))}
                                </Tags>
                            </Col>
                        </Row>
                        <Divider />
                        <Publish>
                            <h4>Publish</h4>

                            <MenuItem
                                onClick={() => {
                                    onClickPublishStat(false);
                                }}
                                display={true}
                                className={publishData.publishNow === false ? "on" : ""}
                            >
                                <Circle />
                                <span>Schedule</span>
                            </MenuItem>

                            <DateItems>
                                <DateItem>
                                    <span>Date</span>
                                    <input
                                        type={"date"}
                                        name="date"
                                        value={dayjs(publishData?.publishDateTime?.split(" ")[0]).format(
                                            "YYYY-MM-DD"
                                        )}
                                        onChange={(e) => {
                                            console.log("e", e.target.value);
                                            const date = new Date(e.target.value);
                                            const day = dayjs(date).format("YYYY-MM-DD");
                                            const data =`${day} ${publishData?.publishDateTime?.split(" ")[1]}`
                                            console.log("day", day);
                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                publishDateTime: dayjs(data).format("YYYY-MM-DD HH:mm:ss"),
                                            });
                                        }}
                                    />
                                </DateItem>
                                <DateItem>
                                    <span>Time</span>
                                    <input
                                        type="time"
                                        name="time"
                                        value={dayjs(publishData?.publishDateTime).format("HH:mm:ss")}
                                        onChange={(e) => {
                                            console.log("eeee@", e.target.value);

                                            const value = e.target.value;

                                            const data = `${publishData?.publishDateTime?.split(" ")[0]} ${value}`;
                                            const dateData = dayjs(data).format("YYYY-MM-DD HH:mm:ss")
                                            console.log("dateData",dateData)

                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                publishDateTime: dateData,
                                            });
                                        }}
                                    />
                                </DateItem>
                                <DateItem>
                                    <span>Timezone</span>
                                    <TimezoneSelect
                                        className="timeZone"
                                        displayValue={"UTC"}
                                        labelStyle={"abbrev"}
                                        timezones={{
                                            ...allTimezones,
                                            "America/Lima": "Pittsburgh",
                                            "Europe/Berlin": "Frankfurt",
                                        }}
                                        value={publishData?.timeZone || getCurrentTimeZone()}
                                        onChange={(e: ITimezone) => {
                                            console.log("e", e);
                                            setPublishData({
                                                ...cloneDeep(publishData),
                                                timeZone: e.value,
                                            });
                                        }}
                                    />
                                </DateItem>
                            </DateItems>
                            <MenuItem
                                onClick={() => {
                                    onClickPublishStat(true);
                                }}
                                display={true}
                                className={publishData.publishNow === true ? "on" : ""}
                            >
                                <Circle />
                                <span>Publich now</span>
                            </MenuItem>
                        </Publish>
                    </AdminContents>
                )}

                <ButtonItems justifyContent={"flex-end"}>
                    <button
                        className={"continue"}
                        onClick={async () => { await putCoachingData() }}>Continue</button>
                </ButtonItems>
            </Container>
        </React.Fragment>
    );
};
export default Details;

const Container = styled.div`
    //overflow-y: scroll;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100%) / 2);
    @media screen and (max-width: 768px) {
        width: 100%;
    }
`;

const FormBox = styled.dl`
    p{
        margin-top: 15px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0em;
        color: #333;
    }
    > dt {
        margin-top: 5px;
        //opacity: 0.8;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
const SearchIconBox = styled.div`
    padding-right: 21px;
    padding-left: 10px;
    position: absolute;
    background: #e5e5e5;
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 105px;
    right: 0;
    top: 0;
    border-radius: 0 8px 8px 0;
    span {
        font-size: 16px;
        font-weight: 700;
    }
`;
const FormItem = styled.div`
    position: relative;
    .topics {
        z-index: 9999;
    }
    .keywords {
        z-index: 999;
    }

    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ccc;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #333333;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
`;

const ThumbnailUpload = styled.div`
    width: 50%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div<StyledComponentProps>`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    input {
        position: absolute;
        z-index: 9;
        width: 100%;
        height: 100%;
        opacity: 0;
    }
    &:hover {
        &::before {
            opacity: 0.3;
        }
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    opacity: 0;
    transition: 0.2s;
    background: #33333340;
    &:hover {
        opacity: 1;
    }
    > li {
        margin: 0 4px;
    }
`;

const UploadText = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    p {
        margin-top: 10px;
        font-size: 18px;
        text-align: center;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: ${(props) => props.justifyContent};
    border-top: solid 1px rgba(51, 51, 51, 0.3);
    button {
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #fff;
        border-radius: 6px;
        background: #ddc160;
    }
`;

const AdminContents = styled.div`
    padding: 30px 20px 20px 20px;
    border-top: solid 1px rgba(51, 51, 51, 0.3);
`;

const Publish = styled.div`
    padding-top: 15px;
    h4 {
        opacity: 0.8;
        font-size: 26px;
        font-weight: 700;
    }
`;

const Check = styled.div``;

const Circle = styled.div`
    transition: all 0.2s;
    .on & {
        border: solid 4px #ddc160;
    }
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border-radius: 8px;
    border: solid 1px #333;
`;

const MenuItem = styled.div<MenuProps>`
    transition: all 0.5s;
    transform: translateX(${(props) => (!props.display ? "-40px" : "none")});
    &.on {
        opacity: 1;
    }
    opacity: 0.6;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 20px 0;
    &:last-child {
        padding-bottom: 0px !important;
    }

    span {
        font-size: 16px;
        font-weight: 600;
        display: flex;
        height: 16px;
        align-items: center;
        padding-top: 3px;
        margin-left: 4px;
    }
`;

const DateItems = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

const DateItem = styled.div`
    display: flex;
    flex-direction: column;
    width: calc((100% - 36px) / 3);
    .timeZone {
        margin-top: 10px;
        height: 48px;
        & > div {
            border: solid 1px rgba(51, 51, 51, 0.3);
            border-radius: 8px;
            & > div {
                cursor: pointer;
                &:nth-child(1) {
                    & > div {
                        height: 38px;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
    input {
        padding: 0 15px;
        display: flex;
        margin-top: 10px;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);

        display: flex;
        align-items: center;
        height: 48px;
    }
`;

const Tags = styled.div`
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
`;
const TagItem = styled.div`
    display: flex;
    margin-bottom: 10px;
    cursor: pointer;
    align-items: center;
    box-shadow: 0px 0px 6px rgba(51, 51, 51, 0.16);
    border-radius: 4px;
    padding: 11px 10px;
    margin-left: 10px;
    div {
        height: 100%;
        display: flex;
        align-items: center;
    }
    &:first-child {
        margin-left: 0px;
    }
    span {
        display: flex;
        color: #333;
        font-weight: 600px;
        margin-right: 6px;
        font-size: 14px;
    }
`;
const Divider = styled.div`
    height: 1px;
    background: rgba(51, 51, 51, 0.3);
    margin-bottom: 20px;
    margin-top: 20px;
    width: calc(100% + 40px);
    transform: translateX(-20px);
`;

const DropdownItem = styled(animated.div)`
    transform: translateX(-10px);
    padding: 0 10px;
    background: #fff;
    width: 100%;
    font-family: Europa-Regular;
    font-size: 16px;
    border-bottom: solid 1px rgba(51, 51, 51, 0.3);
    height: 48px;
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #fff;
    span {
        user-select: none;
    }
`;
